import { useState } from "react";
import {
  manufacturerPayableRemainingUsd,
} from "@/lib/ops/manufacturerPayablesMath";
import type { ManufacturerPayable } from "@/lib/opsManufacturerPayablesClient";

function money(n: number): string {
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function OpsManufacturerPayableRow(props: {
  row: ManufacturerPayable;
  busy: boolean;
  onMarkDue: (row: ManufacturerPayable) => void;
  onMarkPaid: (row: ManufacturerPayable) => void;
  onPay: (row: ManufacturerPayable, paymentUsd: number) => void;
}) {
  const { row } = props;
  const remaining = manufacturerPayableRemainingUsd(row.amount_owed_usd, row.amount_paid_usd);
  const [payAmt, setPayAmt] = useState("");
  const closed = row.status === "paid" || row.status === "void";

  return (
    <li className="flex flex-wrap items-center gap-2 px-3 py-2 text-sm">
      <div className="min-w-0 flex-1">
        <div className="font-medium">
          {row.manufacturer} · {row.category}
        </div>
        <div className="text-xs text-gray-500">
          {row.deal_display_name || (row.deal_id ? row.deal_id.slice(0, 8) : "no deal")} · collected{" "}
          {money(row.collected_usd)} · keep {money(row.allowed_deposit_usd)} · paid{" "}
          {money(row.amount_paid_usd)} · {row.status}
        </div>
      </div>
      <div className="text-right font-semibold">{money(remaining)}</div>
      {!closed ? (
        <div className="flex flex-wrap items-center gap-1">
          <input
            className="w-24 rounded border px-1.5 py-0.5 text-xs"
            type="number"
            min={0.01}
            step="0.01"
            value={payAmt}
            onChange={(e) => setPayAmt(e.target.value)}
            placeholder={remaining.toFixed(2)}
            aria-label="Payment amount"
          />
          <button
            type="button"
            className="rounded border px-2 py-0.5 text-xs"
            disabled={props.busy}
            onClick={() => {
              const n = Number(payAmt);
              if (!Number.isFinite(n) || n <= 0) return;
              props.onPay(row, n);
              setPayAmt("");
            }}
          >
            Record payment
          </button>
          {row.status !== "due" ? (
            <button
              type="button"
              className="rounded border px-2 py-0.5 text-xs"
              disabled={props.busy}
              onClick={() => props.onMarkDue(row)}
            >
              Mark due
            </button>
          ) : null}
          <button
            type="button"
            className="rounded border px-2 py-0.5 text-xs"
            disabled={props.busy}
            onClick={() => props.onMarkPaid(row)}
          >
            Mark paid
          </button>
        </div>
      ) : null}
    </li>
  );
}
